
  export default {
    layout: 'mainPage',
    transition: 'page',
    head() {
      return {
        title: 'Innovation & Content Delivery Center - ICDC'
      }
    }
  }
